import React, {useState} from 'react';
import {AddShoppingCart} from '@mui/icons-material';
import {CircularProgress} from '@mui/material';
import {toast} from 'react-toastify';
import {buildWithoutDeal} from '../domain/ProductSelection.model';
import {useCartContext} from '../../cart/context/CartContext';

/**
 * Añade 1 unidad de un producto habitual al carrito. El add del backend FIJA la
 * cantidad de la linea, asi que se manda lo que ya hay en el carrito mas 1.
 */
export const AddHabitualToCartButton = ({product}) => {
    const [loading, setLoading] = useState(false);
    const {cart, addProduct, loadCartBis} = useCartContext();

    const handleClick = async (event) => {
        event.stopPropagation();
        setLoading(true);
        try {
            const effectiveCart = cart ?? await loadCartBis();
            const unitsInCart = (effectiveCart?.products ?? [])
                .filter((cartProduct) => cartProduct.code === product.code && cartProduct.packParentId == null)
                .reduce((sum, cartProduct) => sum + cartProduct.quantity, 0);
            await addProduct(buildWithoutDeal(product, unitsInCart + 1));
            toast.success(`${product.name} añadido al carrito (1 ud.)`);
        } catch (error) {
            console.error('Failed to add habitual product to cart:', error);
            toast.error('No se pudo añadir al carrito. Puede que se haya agotado el stock.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <button type="button"
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1 w-100"
            onClick={handleClick}
            disabled={loading}>
            {loading ? <CircularProgress size={20}/> : <AddShoppingCart/>}
            Añadir al carrito
        </button>
    );
};
